var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-40p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_21113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_21113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "price_change",
    d: "M13.4471 29.3333H16.2248V27.5278H18.1137C18.5674 27.5278 18.9355 27.3634 19.2179 27.0347C19.5003 26.706 19.6415 26.3241 19.6415 25.8889V21.0349C19.6415 20.5764 19.5003 20.1875 19.2179 19.868C18.9355 19.5486 18.5674 19.3889 18.1137 19.3889H12.697V16.9167H19.6415V14.1389H16.2248V12.3333H13.4471V14.1389H11.5581C11.1045 14.1389 10.7179 14.3032 10.3984 14.632C10.079 14.9607 9.91927 15.3529 9.91927 15.8088V20.6356C9.91927 21.0915 10.079 21.4607 10.3984 21.743C10.7179 22.0255 11.1045 22.1667 11.5581 22.1667H16.8637V24.75H9.91927V27.5278H13.4471V29.3333ZM26.9471 27.9445L29.7248 25.1667H24.1693L26.9471 27.9445ZM24.1693 16.9167H29.7248L26.9471 14.1389L24.1693 16.9167ZM6.11369 35.1667C5.36369 35.1667 4.71323 34.8912 4.16231 34.3403C3.6114 33.7894 3.33594 33.1389 3.33594 32.3889V9.27775C3.33594 8.52775 3.6114 7.87729 4.16231 7.32638C4.71323 6.77546 5.36369 6.5 6.11369 6.5H33.8915C34.6415 6.5 35.292 6.77546 35.8429 7.32638C36.3938 7.87729 36.6693 8.52775 36.6693 9.27775V32.3889C36.6693 33.1389 36.3938 33.7894 35.8429 34.3403C35.292 34.8912 34.6415 35.1667 33.8915 35.1667H6.11369ZM6.11369 32.3889H33.8915V9.27775H6.11369V32.3889Z",
    fill: "#D79304"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceChange);
export default __webpack_public_path__ + "static/media/price_change.017c876e3f88c9738a8fe02d096e162a.svg";
export { ForwardRef as ReactComponent };